/**
 * Calculate the height of the dropdown based on the number of items.
 */
export function getHeight(numberOfItems: number) {
  const itemHeight = 38;
  const maxHeight = 10 * itemHeight;
  const height = numberOfItems * itemHeight;
  return height > maxHeight ? `${maxHeight}px` : `${height}px`;
}
